import { render, staticRenderFns } from "./Relatorio_UtilizacaoxBeneficiario.vue?vue&type=template&id=78adc35c&scoped=true&"
import script from "./Relatorio_UtilizacaoxBeneficiario.vue?vue&type=script&lang=js&"
export * from "./Relatorio_UtilizacaoxBeneficiario.vue?vue&type=script&lang=js&"
import style0 from "./Relatorio_UtilizacaoxBeneficiario.vue?vue&type=style&index=0&id=78adc35c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78adc35c",
  null
  
)

export default component.exports